import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 82 82"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "Layer 2" }, [
      _createElementVNode("path", { d: "M41 82a41 41 0 1 1 41-41 41 41 0 0 1-41 41m0-80a39 39 0 1 0 39 39A39.05 39.05 0 0 0 41 2" }),
      _createElementVNode("path", { d: "M30.93 55.91h-7V33.43h7Zm-3.69-25.29h-.06a3.9 3.9 0 0 1-4.18-3.9c0-2.21 1.69-3.9 4.29-3.9a3.93 3.93 0 0 1 4.23 3.9c0 2.18-1.65 3.9-4.28 3.9M59 55.91h-8V44.28c0-3.05-1.24-5.12-4-5.12a4 4 0 0 0-3.8 2.75 5.2 5.2 0 0 0-.17 1.84v12.16h-7.82s.1-20.6 0-22.48h7.88V37c.47-1.54 3-3.74 7-3.74 5 0 8.91 3.23 8.91 10.19Z" })
    ], -1)
  ])))
}
export default { render: render }